import React, {useEffect, useState} from 'react'
import WhiteArrowRight from '../../../../media/felsv/white_right-arrow_icon.svg'
import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../../../reducers'
import {bindActionCreators} from 'redux'
import {actionsGUCreacionUsuario} from '../../../../actions/action-creators'
import {
  gu_cu_ChangePage,
  gu_cu_Clear,
} from '../../../../actions/gestion-usuario/creacion-usuario/creacionUsuario.actions'
import {DICCIONARIO} from '../../../../constants/Diccionario'
import {isNullOrEmpty} from '../../../../utils/strings.utils'
import {getDateOperacion} from '../../../../utils/stringDate'
import InputPhone from '../../../../components/Inputs/InputPhone'
import SearchSelect from '../../../../components/Inputs/SearchSelect'

const CUStep1Usuario = () => {
  const [disabled, setDisabled] = useState(true)
  const {formUser, formError} = useSelector((state: State) => state.gestionUsuario.creacionUsuario)
  const {tipoDocumento} = useSelector((state: State) => state.catalogos)
  const dispatch = useDispatch()
  const actions = bindActionCreators(actionsGUCreacionUsuario, dispatch)

  useEffect(() => {
    actions.gu_cu_getSucusarles()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (
      formUser.birth_date &&
      formUser.first_name &&
      formUser.last_name &&
      formUser.tipoDocumento &&
      formUser.id_number &&
      formUser.phone_number &&
      !formError.birth_date &&
      !formError.first_name &&
      !formError.last_name &&
      !formError.tipoDocumento &&
      !formError.id_number &&
      !formError.phone_number
    )
      setDisabled(false)
    else setDisabled(true)
  }, [formUser, formError])

  const submit = async (e: any) => {
    e.preventDefault()
    if (await actions.gu_cu_validacionesCreacionUsuarioSiguiente()) return
    dispatch(gu_cu_ChangePage(1))
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any) => {
    actions.gu_cu_FormHandleChange(e)
    actions.gu_cu_validacionesCreacionUsuarioOnBlur(e)
  }

  const cancelar = async () => dispatch(gu_cu_Clear())

  return (
    <form className='card w-form w-100  mt-16' autoComplete='off' onSubmit={submit}>
      <div className='card-basic w-100'>
        <div className='mb-16'>
          <h3 className='card-title l mb-16'>Información del usuario</h3>
          <div className='separador' style={{opacity: '10%'}}></div>
        </div>
        <div className='mt-16'>
          <div className='form-content'>
            <div className='w-layout-hflex h-inputs'>
              <div className='label-input'>
                <label htmlFor='first_name' className='field-label m'>
                  {DICCIONARIO.PRIMER_NOMBRE}
                  <span style={{color: 'red'}}>*</span>
                </label>
                <input
                  autoFocus
                  autoComplete='off'
                  type='text'
                  className='m text-field w-input'
                  name='first_name'
                  placeholder={DICCIONARIO.PRIMER_NOMBRE}
                  id='first_name'
                  value={formUser.first_name}
                  onChange={handleChange}
                  onBlur={actions.gu_cu_validacionesCreacionUsuarioOnBlur}
                  maxLength={15}
                />
                {formError.first_name && <p className='alert s'>{formError.first_name}</p>}
              </div>
              <div className='label-input'>
                <label htmlFor='second_name' className='field-label m'>
                  {DICCIONARIO.SEGUNDO_NOMBRE}
                </label>
                <input
                  autoComplete='off'
                  type='text'
                  className='m text-field w-input'
                  name='second_name'
                  placeholder={DICCIONARIO.SEGUNDO_NOMBRE}
                  id='second_name'
                  value={formUser.second_name}
                  onChange={handleChange}
                  onBlur={actions.gu_cu_validacionesCreacionUsuarioOnBlur}
                  maxLength={15}
                />
                {formError.second_name && <p className='alert s'>{formError.second_name}</p>}
              </div>
              <div className='label-input'>
                <label htmlFor='third_name' className='field-label m'>
                  {DICCIONARIO.TERCER_NOMBRE}
                </label>
                <input
                  autoComplete='off'
                  type='text'
                  className='m text-field w-input'
                  name='third_name'
                  placeholder={DICCIONARIO.TERCER_NOMBRE}
                  id='third_name'
                  value={formUser.third_name}
                  onChange={handleChange}
                  onBlur={actions.gu_cu_validacionesCreacionUsuarioOnBlur}
                  maxLength={15}
                />
                {formError.third_name && <p className='alert s'>{formError.third_name}</p>}
              </div>
            </div>
            <div className='w-layout-hflex h-inputs'>
              <div className='label-input'>
                <label htmlFor='last_name' className='field-label m'>
                  {DICCIONARIO.PRIMER_APELLIDO}
                  <span style={{color: 'red'}}>*</span>
                </label>
                <input
                  autoComplete='off'
                  type='text'
                  className='m text-field w-input'
                  name='last_name'
                  placeholder={DICCIONARIO.PRIMER_APELLIDO}
                  id='last_name'
                  value={formUser.last_name}
                  onChange={handleChange}
                  onBlur={actions.gu_cu_validacionesCreacionUsuarioOnBlur}
                  maxLength={15}
                />
                {formError.last_name && <p className='alert s'>{formError.last_name}</p>}
              </div>
              <div className='label-input'>
                <label htmlFor='last_name2' className='field-label m'>
                  {DICCIONARIO.SEGUNDO_APELLIDO}
                </label>
                <input
                  autoComplete='off'
                  type='text'
                  className='m text-field w-input'
                  name='last_name2'
                  placeholder={DICCIONARIO.SEGUNDO_APELLIDO}
                  id='last_name2'
                  value={formUser.last_name2}
                  onChange={handleChange}
                  onBlur={actions.gu_cu_validacionesCreacionUsuarioOnBlur}
                  maxLength={15}
                />
                {formError.last_name2 && <p className='alert s'>{formError.last_name2}</p>}
              </div>
              <div className='label-input'>
                <label htmlFor='last_name_married' className='field-label m'>
                  {DICCIONARIO.APELLIDO_CASADA}
                </label>
                <input
                  autoComplete='off'
                  type='text'
                  className='m text-field w-input'
                  name='last_name_married'
                  placeholder={DICCIONARIO.APELLIDO_CASADA}
                  id='last_name_married'
                  value={formUser.last_name_married}
                  onChange={handleChange}
                  onBlur={actions.gu_cu_validacionesCreacionUsuarioOnBlur}
                  maxLength={15}
                />
                {formError.last_name_married && (
                  <p className='alert s'>{formError.last_name_married}</p>
                )}
              </div>
            </div>
            <div className='w-layout-hflex h-inputs'>
              <div className='label-input'>
                <label htmlFor='phone_number' className='field-label m'>
                  {DICCIONARIO.TELEFONO}
                  <span style={{color: 'red'}}>*</span>
                </label>
                <InputPhone
                  disabled={false}
                  className='m text-field w-input'
                  value={formUser.phone_number}
                  onChange={actions.gu_cu_FormHandleChangePhone}
                  onBlur={actions.gu_cu_validacionesCreacionUsuarioOnBlur}
                  name='phone_number'
                />
                {formError.phone_number && <p className='alert s'>{formError.phone_number}</p>}
              </div>
              <div className='label-input'>
                <label htmlFor='birth_date' className='field-label m'>
                  {DICCIONARIO.FECHA_NACIMIENTO}
                  <span style={{color: 'red'}}>*</span>
                </label>
                <input
                  autoComplete='off'
                  type='date'
                  className='m text-field w-input'
                  maxLength={10}
                  name='birth_date'
                  data-name='birth_date'
                  placeholder={DICCIONARIO.FECHA_NACIMIENTO}
                  id='birth_date'
                  min={getDateOperacion(-150)}
                  max={getDateOperacion(-18)}
                  value={formUser.birth_date}
                  onChange={handleChange}
                  onBlur={actions.gu_cu_validacionesCreacionUsuarioOnBlur}
                />
                {formError.birth_date && <p className='alert s'>{formError.birth_date}</p>}
              </div>
              <div className='label-input'>
                <label htmlFor='tipoDocumento' className='field-label m'>
                  {DICCIONARIO.TIPO_DOCUMENTO_IDENTIFICACION}
                  <span style={{color: 'red'}}>*</span>
                </label>
                <SearchSelect 
                  defaultValue={null} 
                  data={tipoDocumento} 
                  value={formUser.tipoDocumento} 
                  placeholder={DICCIONARIO.TIPO_DOCUMENTO_IDENTIFICACION} 
                  keyNameText='valor' 
                  keyNameValue='codigo' 
                  disabled = {tipoDocumento.length === 0} 
                  name='tipoDocumento' 
                  onChange={(value: any) => {handleChange({target: {value: value?.value, name: 'tipoDocumento'}}) ; actions.gu_cu_validacionesCreacionUsuarioOnBlur({target: {value: value?.value, name: 'tipoDocumento'}})}}
                />
                {formError.tipoDocumento && <p className='alert s'>{formError.tipoDocumento}</p>}
              </div>
            </div>
            <div className='w-layout-hflex h-inputs'>
              <div className='label-input'>
                <label htmlFor='id_number' className='field-label m'>
                  {formUser.nombreTipoDocumento || DICCIONARIO.NUMERO_DOCUMENTO_IDENTIFICACION}
                  <span style={{color: 'red'}}>*</span>
                  <div style={{maxWidth: 380, fontSize: 11}} className='alert-info-text'>
                  {
                    (formUser.nombreTipoDocumento === 'NIT') &&
                    'Ingresa el número de identificación sin guiones.'  
                  }
                  {
                    (formUser.nombreTipoDocumento === 'DUI') &&
                    'Ingresa el DUI sin guiones.'
                  }
                </div>
                </label>
                <input
                  autoComplete='off'
                  type='text'
                  className='m text-field w-input'
                  maxLength={14}
                  name='id_number'
                  data-name='id_number'
                  placeholder={
                    formUser.nombreTipoDocumento || DICCIONARIO.NUMERO_DOCUMENTO_IDENTIFICACION
                  }
                  id='id_number'
                  disabled={isNullOrEmpty(formUser.tipoDocumento)}
                  value={formUser.id_number}
                  onChange={handleChange}
                  onBlur={actions.gu_cu_validacionesCreacionUsuarioOnBlur}
                />
                {formError.id_number && <p className='alert s'>{formError.id_number}</p>}
              </div>
              <div className='label-input'></div>
              <div className='label-input'></div>
            </div>
          </div>
        </div>
      </div>
      <div className='separador mt-16'></div>
      <div
        className='mt-16 w-100  button-actions'
        style={{display: 'flex', justifyContent: 'space-between'}}
      >
        <button
          type='button'
          className='m button transparent w-inline-block w-auto'
          onClick={cancelar}
        >
          <div>Cancelar</div>
        </button>
        <button type='submit' className='m button w-inline-block w-auto' disabled={disabled}>
          <div>Siguiente</div>
          <img src={WhiteArrowRight} loading='lazy' alt='Siguiente' />
        </button>
      </div>
    </form>
  )
}

export default CUStep1Usuario
